<h5 mat-dialog-title i18n>Customer Summary Report</h5>
<div mat-dialog-content>
  <form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
    <div class="control-wrapper">
      <span i18n>Contacts Only</span>
      <input type="checkbox" name="displayFormat" id="displayFormat"
             class="bidit-switch-sm ml-1 mr-1" [(ngModel)]="data.customerSummary.displayFormat">
      <span i18n>Contacts &amp; Quotes</span>
    </div>
    <hr />
    <p i18n>Please define the filters below</p>
    <div class="form-group row">
      <div class="col-sm-6">
        <div class="control-wrapper">
          <label for="customer_ID" class="col-sm-3 col-form-label" i18n>Customer</label>
          <select name="customer_ID" id="customer_ID"
                  [(ngModel)]="data.customerSummary.customer_ID" #customer_ID="ngModel"
                  class="form-control select-bidit">
            <option value="null">All Customers</option>
            <option *ngFor="let customer of data.customers" [ngValue]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
          </select>
        </div>
      </div>
      <div class="col-sm-6">
        <p i18n>Define Time Frame</p>
        <div class="control-wrapper">
          <label for="year" class="col-sm-3 col-form-label" i18n>Year</label>
          <select name="year" id="year"
                  [(ngModel)]="data.customerSummary.year" #year="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let year of data.years" [ngValue]="year">{{year}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="startMonth" class="col-sm-3 col-form-label" i18n>Start Month</label>
          <select name="startMonth" id="startMonth"
                  [(ngModel)]="data.customerSummary.startMonth" #startMonth="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
          </select>
        </div>
        <div class="control-wrapper">
          <label for="endMonth" class="col-sm-3 col-form-label" i18n>End Month</label>
          <select name="endMonth" id="endMonth"
                  [(ngModel)]="data.customerSummary.endMonth" #endMonth="ngModel"
                  class="form-control select-bidit">
            <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
          </select>
        </div>
      </div>

    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
      <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>
